import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable, NgZone } from '@angular/core';
import { HttpService } from '../../commons/services/http.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PromotionInsertCommand } from '../../commons/class/promotion.class';
import { ENV_TOKEN } from '../../app-module.token';


@Injectable({
  providedIn: 'root',
})
export class GatewayService {
  headers = new HttpHeaders();
  public constService: any;
  urlRaiz!: string;

  private httpService: HttpService = inject(HttpService);
  private zone: NgZone = inject(NgZone);
  private router: Router = inject(Router);
  readonly environment = inject(ENV_TOKEN);
  constructor() {
    this.constService = this.environment;
    this.urlRaiz = this.constService.gateway;
  }

  /**
   * Consulta la información de un asunto
   * @param request 
   * @returns 
   */
  consultAffair(request: any): Observable<any> {
    const funcion = "icoij/ConsultMatter";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request)
  }

  /**
   *  Envía una promoción al sistema, se construye la ruta para el envío utilizando la URL raíz y la función correspondiente, se hace una petición POST al servicio utilizando la ruta construida y el objeto de solicitud proporcionado, se retorna la respuesta del servicio
   * @param request 
   * @returns 
   */
  EnvioPromocion(request: PromotionInsertCommand) {
    const funcion = "icoij/registerPromotion";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request)
  }

  /**
   * Obtiene el acuse de una promoción
   * @param idPromocion 
   * @returns 
   */

  GetAcusePromocion(idPromocion: number) {
    const funcion = "icoij/getAcusePromotionElect";
    const ruta = `${this.urlRaiz}/${funcion}/${idPromocion}`;
    return this.httpService.getRequest(ruta)
  }

}
